var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVcaCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.2,314.5l-54.1-151.3h33.1l38.3,112,37.1-112h32.4l-54.2,151.3h-32.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.4,258.9l29.6,9.4c-4.5,16.5-12.1,28.8-22.7,36.8s-24,12-40.2,12-36.6-6.9-49.5-20.6-19.4-32.5-19.4-56.3,6.5-44.7,19.5-58.7c13-13.9,30.1-20.9,51.3-20.9s33.5,5.5,45.1,16.4c6.9,6.5,12,15.8,15.5,27.9l-30.2,7.2c-1.8-7.8-5.5-14-11.2-18.6-5.7-4.5-12.6-6.8-20.7-6.8s-20.3,4-27.3,12.1-10.5,21.1-10.5,39.1,3.4,32.8,10.3,40.9,15.8,12.2,26.8,12.2,15.1-2.6,21-7.7c5.8-5.2,10-13.3,12.6-24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.7,314.5h-33.2l-13.2-34.4h-60.5l-12.5,34.4h-32.4l58.9-151.3h32.3l60.6,151.3h0ZM569.5,254.7l-20.9-56.2-20.4,56.2h41.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M736.1,47.5H63.9c-12.3,0-22.4,9.9-22.4,22.3v463.2c0,12.4,10,22.4,22.4,22.4h299.8c-19.9-17.6-34.5-40.6-30.3-67.2h-202.3c-12.4,0-22.4-10-22.4-22.4V137.1c0-12.4,10-22.4,22.3-22.4h537.8c12.4,0,22.4,10,22.4,22.4v242.2c5.7,12.6,3.8,36.3,4.2,50l19.7,19.9c31.5,33.2,22,78.7-11.8,106.2h32.7c12.3,0,22.3-10.1,22.4-22.4V69.7c0-12.3-10.1-22.2-22.4-22.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.5,657.9l-61.8.4-28.5,28.1,22.2,61.2c1.4,3.9,5.7,5.9,9.6,4.5,1.9-.7,3.4-2.1,4.2-3.9l20.8-44.5,44.3,20.7c3.7,1.7,8.2,0,9.9-3.6.8-1.8.9-3.9.3-5.7l-20.9-57.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.8,657.9l-20.9,57.3c-1.4,3.9.6,8.2,4.5,9.6,1.9.7,3.9.6,5.7-.3l44.3-20.7,20.8,44.5c1.7,3.7,6.2,5.4,9.9,3.6,1.8-.8,3.2-2.4,3.9-4.2l22.2-61.1-28.7-28.2-61.7-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.8,447.8l-.3-46.2c0-12.2-10-22.1-22.2-22.2l-46.2-.3-32.9-32.4c-8.7-8.6-22.7-8.6-31.4,0l-32.9,32.4-46.2.3c-12.2,0-22.1,10-22.2,22.2l-.3,46.2-32.4,32.9c-8.6,8.7-8.6,22.7,0,31.4l32.4,32.9.3,46.2c0,12.2,10,22.1,22.2,22.2l46.2.3,32.9,32.4c8.7,8.6,22.7,8.6,31.4,0l32.9-32.4,46.2-.3c12.2,0,22.1-10,22.2-22.2l.3-46.2,32.4-32.9c8.6-8.7,8.6-22.7,0-31.4l-32.4-32.9ZM533.6,556.1c-79-2.4-79-117.1,0-119.5,79,2.4,79,117.1,0,119.5h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcaCertificate);
export default __webpack_public_path__ + "static/media/vca-certificate.370814ec44bfc00b00a58a2ebd3b3cc6.svg";
export { ForwardRef as ReactComponent };